import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { sortBy } from 'lodash';
import moment from 'moment';
import {isMobile} from 'react-device-detect';

// material
import { withStyles, Theme } from '@material-ui/core/styles';
import { Grid, Hidden, Dialog, FormControl, MenuItem, Select, InputLabel } from '@material-ui/core';
// app
import { updateSession, addAuth, openSnackbar, closeSnackbar } from '../../store/action-creators';
// containers
import AppContainer from '../../containers/App';
import ActionButton from '../../components/buttonsComponent/ActionButton';
import BackButton from '../../components/buttons/BackButton';
import ContactList from "./contactList";
import ContactInfo from "./contactInfo";
import { CONTACTS_INFO } from "./data";
import { PhoneIcon } from "../../assets";
import EmptyScreen from "./EmptyPage";
import CallModal from "./Modal";
import HistoryDetails from "./contactInfo/history";
import ContactActions from "./contactInfo/contactActions";
import Loading from '../../components/site/Loading';
// entities
import { Auth, Session } from '../../entities/auth';
import { Campaign, Lead, CampaignContact, emptyCampaignContact } from '../../entities/site';
import { Message } from '../../entities/notification';
import { History } from './types';
import { CampignContactNote } from '../../entities/site';
// services
import CampaignService from '../../services/campaign';
import AuthService from '../../services/auth';

export enum Actions {
  call,
  text,
  note
}

const styles: any = (theme: Theme) => ({
  title: {
    fontSize: "26px",
    fontFamily: "Roboto",
    fontWeight: "500",
    lineHeight: "30px",
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: "20px",
      whiteSpace: "nowrap",
      marginTop: "-25px",
      "& span": {
        marginTop: "50px",
        marginLeft: "-105px",
      }
    }
  },
  dateText: {
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: "500",
    lineHeight: "19px",
    color: "#627995",
    marginLeft: "30px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down('xs')]: {
      fontSize: "12px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "14px",
    }
  },
  campaignContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "25px 42px 25px 30px",
    alignItems: "center",
    [theme.breakpoints.down('xs')]: {
      padding: "20px",
    }
  },
  campaigndiv: {
    padding: "0px 20px",
    marginBottom: "100px",
    [theme.breakpoints.down('sm')]: {
      padding: "0px !important",
    }
  },
  tabdiv: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down('xs')]: {
      display: "block",
    },
    marginTop: 20,
    marginBottom: 10
  },
  newcampaign: {
    color: "#627995",
    fontSize: "17px",
    marginTop: "30px",
    [theme.breakpoints.down('xs')]: {
      marginTop: "0px",
      marginBottom: "15px",
      fontSize: "16px",
    }
  },
  newcampaignMobile: {
    textAlign: 'center',
    color: "#627995",
    fontSize: "17px",
    marginTop: "30px",
    [theme.breakpoints.down('xs')]: {
      marginTop: "0px",
      marginBottom: "15px",
      fontSize: "16px",
    }
  },
  gridContainer: {
    border: "1px solid #E0E0E0",
    height: "calc(100vh - 241px)"
  },
  infoContainer: {
    padding: "30px 40px",
    width: "calc(100vw - 330px)"
  },
  listContainer: {
    borderRight: "1px solid #E0E0E0",
    background: "#F4F7FC",
    maxWidth: 330
  },
  h100: {
    height: "100px",
  },
  contactListSection: {
    background: "#F4F7FC",
    [theme.breakpoints.down('sm')]: {
      maxHeight: "calc(100vh - 150px)",
      overflow: "auto"
    }
  },
  detailSection: {
    padding: "40px",
  },
  contactDetail: {
    paddingRight: "40px",
    paddingTop: "40px",
    minHeight: "calc(100vh - 340px)",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      minHeight: "auto"
    },
  },
  contactDetailMedium: {
    paddingTop: "40px",
  },
  detailSectionEmpty: {
    minHeight: "calc(100vh - 240px)",
    padding: "40px",
  },
  border: {
    border: "1px solid #E0E0E0"
  },
  borderTop: {
    borderTop: "1px solid #E0E0E0"
  },
  borderBottom: {
    borderBottom: "1px solid #E0E0E0"
  },
  borderLeft: {
    borderLeft: "1px solid #E0E0E0"
  },
  borderRight: {
    borderRight: "1px solid #E0E0E0"
  },
  p40: {
    padding: "40px !important"
  },
  m0: {
    margin: "0 !important",
  },
  p0: {
    padding: "0 !important"
  },
  sectionHeader: {
    marginTop: "-40px",
    padding: "30px 0",
    [theme.breakpoints.down('sm')]: {
      marginTop: "0px",
      padding: "20px 40px",
    },
    [theme.breakpoints.down('xs')]: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      background: "white"
    },

  },
  sectionHeaderMedium: {
    marginTop: "-40px",
    padding: "30px 0",
  },
  textRight: {
    textAlign: "right"
  },
  scrollableSection: {
    maxHeight: "calc(100vh - 150px)",
    overflow: "auto"
  },
  smSubHeader: {
    // position: "sticky",
    // top: "90px",
    // zIndex: 1,
    // margin: "0 -40px",
    // padding: "0 40px",
    // background: "white"

    "right": "10px",
    "bottom": "10px",
    "position": "fixed",
    "display": "flex",
    "flexDirection": "column",
    "zIndex": "1",
    "gap": "10px"
  }
})

interface NextActionProps {
  history: any;
  auth: Auth;
  session: Session;
  updateSession(session: Session): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface NextActionPageState {
  selectedRow: Lead | null,
  selectedContact: CampaignContact,
  selectedContactHistory: History[],
  showCallPopup: boolean,
  contacts: any[],
  showResponsivePopup: boolean,
  loading: boolean,
  loadingContacts: boolean,
  campaigns: Campaign[],
  campaignId: string,
  campaignName: string,
  messageGroupId: string,
  messageGroupPhone: string,
  leads: Lead[];
}

const popUpContent = {
  message: <><span>Note</span>Your phone will be called before you are connected with the other party</>,
  primaryAction: "Call Now",
  footer: <>Up Next:<span>&nbsp;Debbie Richardson&nbsp;</span></>,
  campaign: true
}


class NextActionPage extends Component<NextActionProps, NextActionPageState> {
  
  private pageRef: any;

  constructor(props: NextActionProps) {
    super(props)
    this.state = {
      selectedRow: null,
      selectedContact: emptyCampaignContact,
      selectedContactHistory: [],
      showCallPopup: false,
      contacts: CONTACTS_INFO,
      showResponsivePopup: false,
      loading: false,
      loadingContacts: false,
      campaigns: [],
      campaignId: '',
      campaignName: '',
      messageGroupId: '',
      messageGroupPhone: '',
      leads: []
    }

  }

  fetchCampaigns = async () => {

    try {

      this.setState({ loading: true });

      // let totalLeads = 0;
      const campaignsRes = await axios.get(`${AuthService.getApiUrls().site}/campaigns?status=active&limit=500`);
      const filtered = sortBy(campaignsRes.data.results, 'createdDate').reverse();

      // const campaignsRes = await axios.get(`${AuthService.getApiUrls().site}/campaign/e2c9ff00-0a59-11ee-afb5-37aba1e820f3`);
      // const filtered = [campaignsRes.data];

      // campaignsRes.data.results.map((campaign: Campaign) => {
      //   totalLeads = totalLeads + campaign.totalLeads;
      // });

      const campaignId = filtered.length ? filtered[0].id : '';
      const campaignName = filtered.length ? filtered[0].name : '';

      this.setState({
        campaigns: filtered,
        campaignId,
        campaignName
      });
      if (filtered.length) {
        this.fetchLeads(filtered[0].id);
      }

    } catch (error) {
      console.log('error', error);
    } finally {
      this.setState({ loading: false });
    }

  }

  fetchLeads = async (campaignId: string) => {
    try {
      this.setState({ loading: true });

      const leadsRes = await axios.get(`${AuthService.getApiUrls().site}/leads/campaign/${campaignId}`);
      const sortedLeads = leadsRes.data.results.sort((a: Lead, b: Lead) => b.newMessage - a.newMessage);
      const selectedLead = sortedLeads.length ? sortedLeads[0] : null;
      
      this.setState({
        leads: leadsRes.data.results,
        selectedRow: selectedLead
      });
      
      if (selectedLead) {
        this.fetchContact(selectedLead.contactId)
      }

    } catch (error) {
      console.log('error', error);
    } finally {
      this.setState({ loading: false });
    }
  }

  fetchContact = async (contactId: string) => {
    try {
      this.setState({ loadingContacts: true });

      const contactRes = await axios.get(`${AuthService.getApiUrls().site}/campaign/contact/${contactId}`);
      // get message group
      const messageGroupRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/group/contact/${contactId}`);
      // get messages
      const messages = await axios.get(`${AuthService.getApiUrls().notifications}/messages/group/${messageGroupRes.data.id}`);
      let sortedMessages = sortBy(messages.data, 'createdDate');
      sortedMessages = sortedMessages.reverse();
      // get notes
      const notesRes = await axios.get(`${AuthService.getApiUrls().site}/campaign/contacts/notes/campaign/${this.state.campaignId}/contact/${contactId}`);
      const notes = notesRes.data.results;

      const newHistory: History[] = [];
      sortedMessages.forEach((message: Message) => {
        newHistory.push({
          type: "text",
          date: message.createdDate,
          from: message.fromPhoneNumber,
          data: message.message
        })
      });
      notes.forEach((note: CampignContactNote) => {
        newHistory.push({
          type: "note",
          date: note.createdDate,
          from: note.userName,
          data: note.note
        })
      })
      const newHistorySorted = sortBy(newHistory, 'date').reverse();
      console.log('newHistory', newHistory)
      this.setState({
        selectedContact: contactRes.data,
        selectedContactHistory: newHistorySorted,
        messageGroupId: messageGroupRes.data.id,
        messageGroupPhone: messageGroupRes.data.fromPhoneNumber
      });
    } catch (error) {
      console.log('error', error);
    } finally {
      this.setState({ loadingContacts: false });
    }
  }

  handleAction = async (action: Actions, actionData: any) => {
    try {

      console.log('action', action);
      console.log('actionData', actionData);

      if (!actionData && this.state.selectedRow) {
        return;
      }

      const user = this.props.auth.user;

      this.setState({ loading: true });

      if (action === Actions.text) {
        const messageRes = await CampaignService.sendMessage(
          AuthService.getApiUrls().notifications,
          this.props.auth.user,
          this.state.messageGroupId,
          this.state.selectedContact.phoneNumber,
          this.state.messageGroupPhone,
          actionData.message
        );

        // set new message?
        const leadRes = await axios.put(`${AuthService.getApiUrls().site}/lead/${this.state.selectedRow?.id}/contact/${this.state.selectedContact?.id}`, {
          disposition: actionData.disposition,
          newMessage: false,
          nextAction: 'followedUp'
        });
      }

      if (action === Actions.note) {
        // send to new endpoint
        const noteParam = {
          userId: user?.userId,
          userName: user?.name,
          campaignId: this.state.campaignId,
          campaignName: this.state.campaignName,
          contactId: this.state.selectedContact.id,
          contactFirstName: this.state.selectedContact.firstName,
          contactLastName: this.state.selectedContact.lastName,
          contactEmail: this.state.selectedContact.email,
          contactPhone: this.state.selectedContact.phoneNumber,
          note: actionData.message
        };
        const noteRes = await axios.post(`${AuthService.getApiUrls().site}/campaign/contact/note`, noteParam);
      }

      if (action === Actions.call) {
        // update lead
        const leadRes = await axios.put(`${AuthService.getApiUrls().site}/lead/${this.state.selectedRow?.id}/contact/${this.state.selectedContact?.id}`, {
          disposition: actionData.disposition,
          newMessage: false,
          nextAction: 'followedUp'
        });

        // open ytel widget
        // @ts-ignore: Unreachable code error
        // YtelWebphone.openWebphone(true);
        // const script = document.createElement("script");
        // script.innerHTML = `YtelWebphone.openWebphone(true)`;
        // document.body.appendChild(script);
      }

      // this.fetchContact(this.state.selectedContact.id)
      this.fetchLeads(this.state.campaignId);

    } catch (error) {
      console.log('error', error);
      this.setState({ loading: false });
    }
  }

  handleUpdateContact = async (contact: CampaignContact, disposition: string) => {
    try {

      this.setState({ loadingContacts: true });

      const data = {
        disposition,
        status: contact.status
      }
      
      await axios.put(`${AuthService.getApiUrls().site}/campaign/contact/${contact.id}`, data);

      await axios.put(`${AuthService.getApiUrls().site}/lead/${this.state.selectedRow?.id}/contact/${this.state.selectedContact?.id}`, {
        disposition,
        newMessage: false
      });

      this.fetchLeads(this.state.campaignId);

      // TODO: set next action

    } catch (error) {
      console.log('error', error);
    } finally {
      this.setState({ loadingContacts: false });
    }
  }

  handleChange = async (event: React.ChangeEvent<{ value: string }>) => {

    try {

      const campaignId = event.target.value;
      const campaign = this.state.campaigns.find((c) => c.id === campaignId);
      const campaignName = campaign?.name || '';
      this.setState({
        campaignId,
        campaignName,
        loading: true,
        selectedContact: emptyCampaignContact,
        selectedContactHistory: [],
      });

      this.fetchLeads(event.target.value);

    } catch (error) {
      this.setState({ loading: false });
      console.log('error', error);
    }

  };

  handleRowCallback = (row: Lead) => {
    this.setState({ selectedRow: row })
    this.fetchContact(row.contactId);
  }

  toggleResponsivePopup = () => {
    this.setState({ selectedRow: null })
  }

  toggleCallEveryone = () => {
    this.setState({ showCallPopup: !this.state.showCallPopup })
  }

  handleCallCallback = () => {
    console.log("Clicked")
  }


  componentDidMount = async () => {
    this.fetchCampaigns();

    // if (!document.getElementById('dialer') && !isMobile) {
    //   // inject dialer into page
    //   const script = document.createElement("script");
    //   script.async = true;
    //   script.id = 'dialer';
    //   script.innerHTML = `const config = {
    //         username: 'jay@micazza.com',
    //         password: '2390Gal!l@io',
    //         wrapperId: 'root',
    //         features: {
    //           phone: true,
    //           sms: false,
    //           video: false,
    //           contacts: false,
    //           liveList: false,
    //           agentsStatus: false,
    //           voicemail: false,
    //           recentConversations: false,
    //           workflow: false,
    //         },
    //         options: {
    //           defaultOpenMainDialer: false
    //         }
    //     };
    //     YtelWebphone.init(config);
    //     setTimeout(() => YtelWebphone.openWebphone(false), 1000);
    //   `;
    //   document.body.appendChild(script);
    // }
  }

  render() {
    const { classes }: any = this.props;
    const { selectedRow, selectedContact, selectedContactHistory, contacts, showResponsivePopup }: NextActionPageState = this.state

    return (
      <AppContainer showOption={false} private={false} fullHeight>
        <Loading open={this.state.loading || this.state.loadingContacts} />
        <div style={{ padding: 10 }}>
          <FormControl variant="outlined" className={classes.formControl} size="small">
            <InputLabel style={{ color: "#5A72A2" }} id="campaign-label">Campaigns</InputLabel>
            <Select
              labelId="campaign"
              id="campaign"
              value={this.state.campaignId}
              onChange={this.handleChange}
              label="All Campaigns"
            >
              <MenuItem value={""}>All</MenuItem>
              {this.state.campaigns.map((campaign: Campaign, index) => (
                <MenuItem value={campaign.id} key={`campaign-${index}`}>{`${campaign.name} - ${campaign.totalLeads} leads`}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className={`${classes.campaignContainer} ${classes.borderBottom}`}>
          <div className={classes.title}>Next Action <span className={classes.dateText}>{moment(new Date()).format('MMM DD, YYYY')} | {this.state.leads.length} leads</span></div>
          <div style={styles.button}>
            {/* <ActionButton onClick={this.toggleCallEveryone} >
              <PhoneIcon />
              <Hidden xsDown>
                &nbsp;&nbsp;Call Everyone
              </Hidden>
            </ActionButton> */}
          </div>
        </div>
        <Grid container >
          <Grid item xs={12} sm={6} md={4} lg={3} className={`${classes.borderRight} ${classes.contactListSection}`}>
            <div style={{overflowY: 'scroll', maxHeight: 600}}>
              <ContactList
                data={this.state.leads}
                handleRowCallback={this.handleRowCallback}
                selectedRowId={selectedRow?.id || null}
              />
            </div>
          </Grid>
          <Hidden smDown>
            {
              selectedRow ? (
                <Grid container md={8} lg={9} className={classes.detailSection}>
                  <Grid container md={12} justify="space-between" className={`${classes.sectionHeader} ${classes.borderBottom}`}>
                    <span className={classes.title}>{selectedRow?.name}</span>
                    <div className={classes.dateText}><span>Click Date: </span>{moment(selectedRow.createdDate).format("MMM DD, YYYY")}</div>
                  </Grid>
                  <Grid container>

                    <Grid item md={6} className={`${classes.contactDetail} ${classes.borderRight}`}>
                      <ContactInfo contact={selectedContact} onClick={this.handleUpdateContact} />
                    </Grid>
                    <Grid item md={6}>
                      <HistoryDetails history={selectedContactHistory} contact={selectedContact} onAction={this.handleAction} />
                    </Grid>
                  </Grid>
                </Grid>
              ) :
                <Grid container md={8} lg={9} className={classes.detailSectionEmpty}>
                  <EmptyScreen message="You have nothing to view here" />
                </Grid>
            }
          </Hidden>
          <Hidden only={['xs', 'md', 'lg', 'xl']}>
            <Grid container sm={6} className={classes.scrollableSection}>
              {

                selectedRow ? (
                  <Grid item sm={12} className={`${classes.p40}`}>
                    <Grid container sm={12} justify="space-between" alignItems='center' className={`${classes.sectionHeaderMedium} ${classes.borderBottom}`}>
                      <span className={classes.title}>{selectedRow?.name}</span>
                      <div className={`${classes.dateText} ${classes.m0} ${classes.textRight}`}>
                        <div>Click Date</div>
                        {moment(selectedRow.createdDate).format("MMM DD, YYYY")}
                      </div>
                    </Grid>
                    <Grid item md={6} className={`${classes.contactDetailMedium}`}>
                      <ContactInfo contact={selectedContact} onClick={this.handleUpdateContact} />
                    </Grid>
                    <HistoryDetails history={selectedContactHistory} contact={selectedContact} onAction={this.handleAction} />
                  </Grid>
                ) : (
                  <Grid container sm={12} className={classes.detailSectionEmpty}>
                    <EmptyScreen message="You have nothing to view here" />
                  </Grid>
                )
              }

            </Grid>
          </Hidden>
        </Grid>
        {/* <CallModal
          open={this.state.showCallPopup}
          contact={selectedContact}
          title={"Call Entire List"}
          {...popUpContent}
          primaryActionCallback={this.handleCallCallback}
          onClose={this.toggleCallEveryone}
        /> */}
        <Hidden smUp>
          <Dialog
            fullScreen
            open={!!selectedRow}
            onClose={this.toggleResponsivePopup}
          >
            <Grid container sm={12}>
              <Grid container sm={12} justify="space-between" className={`${classes.sectionHeader} ${classes.borderBottom}`}>
                <div>
                  <div className={`${classes.title} ${classes.m0}`}>{selectedRow?.name}</div>
                  <div className={`${classes.dateText} ${classes.m0}`}>
                    <span>Click Date: {moment(selectedContact.createdDate).format('MMM DD, YYYY')}</span>
                  </div>
                </div>
                <BackButton textMobile="Close" text="Close" onClick={this.toggleResponsivePopup} />
              </Grid>
              <Grid item sm={12} className={`${classes.contactDetail} ${classes.p40}`}>
                <div className={classes.smSubHeader}>
                  <ContactActions contact={selectedContact} onAction={this.handleAction} />
                </div>
                <ContactInfo contact={selectedContact} onClick={this.handleUpdateContact} />
                  <HistoryDetails history={selectedContactHistory} contact={selectedContact} onAction={this.handleAction} />
              </Grid>
            </Grid>
          </Dialog>
        </Hidden>
      </AppContainer>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession, openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(withStyles(styles)(NextActionPage)));



// WEBPACK FOOTER //
// ./src/pages/next-action/NextAction.tsx